declare var slideToggle: any;
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CustomStore } from 'devextreme/common/data';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserModel } from 'app/core/models/user.model';
import { AppMenuService } from 'app/service/app-menus.service';
import { AppSettings } from '../../service/app-settings.service';
import { NotificationService } from 'app/service/notification.service';
import { modalLgOptions, modalMdOptions, modalXlOptions } from 'app/core/constants';
import { COMMON_SERVICE, CommonInterface } from 'app/core/services/common.interface';
import { MenuFilterModalComponent } from '../menu-filter-modal/menu-filter-modal.component';
import { Component, Input, Output, EventEmitter, OnDestroy, Inject, OnInit } from '@angular/core';
import { StoreStateService, USER_AUTHENTICATION_SERVICE, UserAuthInterface } from 'app/core/services';
import { ProductListModalComponent } from '../product-filter-list-modal/product-filter-list-modal.component';
import { ConfirmStoreChangeModalComponent } from '../confirm-store-change-modal/confirm-store-change-modal.component';

@Component({
	selector: 'header',
	templateUrl: './header.component.html',
	standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
	//#region Fields & Properties
	@Input() appSidebarTwo;
	@Output() appSidebarEndToggled = new EventEmitter<boolean>();
	@Output() appSidebarMobileToggled = new EventEmitter<boolean>();
	@Output() appSidebarEndMobileToggled = new EventEmitter<boolean>();
	@Output() notificationPanelToggled = new EventEmitter<boolean>();
	currentUser: UserModel;
	selectedStoreId: number | string | null = null;
	subscription: Subscription;
	dataSource: CustomStore;
	unreadCount: number = 0;
	roleName: string = '';

	private _isFirstStoreEmit = true;
	//#endregion

	//#region Constructor
	constructor(
		public appSettings: AppSettings,
		@Inject(NgbModal) private _ngbModalService: NgbModal,
		@Inject(COMMON_SERVICE) private _commonService: CommonInterface,
		private _router: Router, private _storeState: StoreStateService,
		@Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface,
		private appMenuService: AppMenuService, private _notificationService: NotificationService,
	) { };
	//#endregion

	//#region Methods
	ngOnInit(): void {
		this.currentUser = this._userAuthInterface.authenticatedUser;
		this.roleName = this.currentUser?.roleName?.toLowerCase() ?? '';
		const existingStoreId = this._storeState.getStoreId();
		const existingStoreFlag = this._storeState.getStoreFlag();
		if (!existingStoreId && this.currentUser?.storeId != null) {
			const selectedStore = this.currentUser.userAccessibleStoreList?.find(s => s.value === this.currentUser.storeId.toString());
			this._storeState.setStoreIdAndFlag(
				this.currentUser.storeId,
				selectedStore?.isKisnaStore ?? false,
				selectedStore?.isCoco ?? false,
			);
		}

		this.subscription = this._storeState.storeId$.subscribe(id => {
			if (id != null) {
				this.selectedStoreId = id.toString();

				if (!this._isFirstStoreEmit) {
					this.loadUnreadCount();
				}
				this._isFirstStoreEmit = false;
			}
		});

		this.loadUnreadCount();
	}

	loadUnreadCount(): void {
		this._commonService.getNotificationsUnreadCount().subscribe({
			next: (res) => {
				this.unreadCount = res.data ?? 0;
			},
			error: (err) => console.error('Failed to load unread count:', err)
		});
	}

	goToProfile() {
		this._router.navigate(['user/user-profile']);
	}

	goToReleaseNotes() {
		this._router.navigate(['/release-notes']);
	}

	onStoreChange(newStore: any) {
		if (!newStore?.value) return;
		const modalRef = this._ngbModalService.open(ConfirmStoreChangeModalComponent, modalMdOptions);
		modalRef.componentInstance.storeName = newStore.text;
		modalRef.result.then(result => {
			if (result === true) {
				this._storeState.setStoreIdAndFlag(newStore.value, newStore.isKisnaStore, newStore.isCoco);
				this._router.navigate(['/kisna-live-dashboard']);
				return;
			}
			else {
				this.selectedStoreId = this._storeState.getStoreId();
			}
		}).catch(() => {
			this.selectedStoreId = this._storeState.getStoreId();
		});
	}


	toggleAppSidebarMobile() {
		this.appSidebarMobileToggled.emit(true);
	}

	toggleAppSidebarEnd() {
		this.appSidebarEndToggled.emit(true);
	}

	toggleAppSidebarEndMobile() {
		this.appSidebarEndMobileToggled.emit(true);
	}

	toggleNotificationPanel() {
		this.notificationPanelToggled.emit(true);
	}

	toggleAppTopMenuMobile() {
		var target = document.querySelector('.app-top-menu');
		if (target) {
			slideToggle(target);
		}
	}

	toggleAppHeaderMegaMenuMobile() {
		this.appSettings.appHeaderMegaMenuMobileToggled = !this.appSettings.appHeaderMegaMenuMobileToggled;
	}

	ngOnDestroy(): void {
		this.appSettings.appHeaderMegaMenuMobileToggled = false;
		this.subscription?.unsubscribe();
	}

	logoutUser() {
		this._userAuthInterface.logoutUser().subscribe({
			next: () => {
				this._storeState.clearStore();
				this._router.navigate(['/account/login']);
			},
			error: () => {
				this._storeState.clearStore();
				this._router.navigate(['/account/login']);
			}
		});
	}

	onGlobalSearch(value: string): void {
		const input = (value ?? '').toLowerCase().trim();
		if (!input) return;

		const menus = this.appMenuService.getAppMenus();
		const permissions = this.permissionList;
		const filteredMenus = this.filterMenus(menus, input, permissions);

		if (!filteredMenus.length) {
			this.openProductListModal(input);
			return;
		}

		(document.activeElement as HTMLElement)?.blur();
		this.openMenuFilterModal(filteredMenus);
	}

	openProductListModal(searchText: string): void {
		const modalRef = this._ngbModalService.open(ProductListModalComponent, modalXlOptions);
		modalRef.componentInstance.searchText = searchText;
		modalRef.result.then(
			result => console.log('Modal closed with result:', result),
		).catch((error) => {
			this._notificationService.showError(error, 'Error');
			console.error('Error opening modal:', error);
		});
	}

	private filterMenus(menus: any[], search: string, perms: string[]): any[] {
		return menus
			.map(menu => {
				const hasAccess = this.hasDirectPermission(menu, perms);
				const titleMatches = menu.title?.toLowerCase().includes(search);
				const filteredSubmenus = menu.submenu ? this.filterMenus(menu.submenu, search, perms) : [];
				if ((titleMatches && hasAccess) || filteredSubmenus.length > 0) {
					return {
						...menu,
						submenu: filteredSubmenus
					};
				}
				return null;
			})
			.filter(Boolean);
	}

	private hasDirectPermission(menu: any, perms: string[]): boolean {
		if (!menu.systemNameList?.length && !menu.childSystemNameList?.length) {
			return true;
		}
		const hasSystemPerm = !menu.systemNameList?.length ||
			menu.systemNameList.some((p: string) => perms.includes(p));
		const hasChildPerm = !menu.childSystemNameList?.length ||
			menu.childSystemNameList.some((p: string) => perms.includes(p));
		return hasSystemPerm && hasChildPerm;
	}

	private get permissionList(): string[] {
		return this._userAuthInterface.authenticatedUserPermissions || [];
	}

	private openMenuFilterModal(filteredMenus: any[]): void {
		const modalRef = this._ngbModalService.open(MenuFilterModalComponent, modalLgOptions);
		modalRef.componentInstance.filteredMenus = filteredMenus;

		modalRef.result.then(
			result => console.log('Modal closed with result:', result),
			reason => console.log('Modal dismissed:', reason)
		);
	}

	//#endregion

}